export const PLATFORM_SYMBOLS = {
    QS: 'Apollo Qual Scheduler',
    IRIS: 'IRIS'

  }
  
  export const getPlatformSymbol = (code) => {
    return PLATFORM_SYMBOLS[code] || code
  }